import { render, staticRenderFns } from "./logicSettingsItem1.vue?vue&type=template&id=0498531c&scoped=true&"
import script from "./logicSettingsItem1.vue?vue&type=script&lang=js&"
export * from "./logicSettingsItem1.vue?vue&type=script&lang=js&"
import style0 from "./logicSettingsItem1.vue?vue&type=style&index=0&id=0498531c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0498531c",
  null
  
)

export default component.exports